/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "view-order",
	props:{
		orderId:{
			default: null
		},
		orderDeliveryId: {
			default: null
		},
		orderDeliveryScheduleId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			reasonsForDeliveryFailure: [],
			deliveryProcessFeatureFlags: {},
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			dateOfCompletion:{
				value: new Date(),
				errorMessage: null,
				hasError: false,
				initialiseDate: true
			},
			orderItemsHasError: false,
			orderItemsErrorMessage: null,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null,
				orderTypeId: null
			},
			orderItemsDispensed: [],
			cancelOrderModalId: "cancelOrderModal",
			markAsOnDeliveryModalId: "markAsOnDeliveryModal",
			cancelOrderScheduledForDeliveryModalId: "cancelOrderScheduledForDeliveryModal",
			completeOrderConfirmationModalId: "completeOrderConfirmationModal",
			orderStatus: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getOrder(){
			this.loading = true;
			this.orderStatus = orderHelper.orderStatus;
			console.log("orderStatus", this.orderStatus);
			orderService.getOrderForDelivery(this.orderId, this.orderDeliveryId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrency(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrency(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerShippingAddresses();
						this.getCustomerBillingAddress();
						this.getReasonsForDeliveryFailure();
					}
					this.loading = false;
					setTimeout(function (){
						var btnViewOrderCancel = document.getElementById("btnViewOrderCancel");
						var btnViewOrderDownload = document.getElementById("btnViewOrderDownload");
						var btnViewOrderViewTrackingHistory = document.getElementById("btnViewOrderDownload");
						var viewOrderActions = document.getElementById("viewOrderActions");
						if(btnViewOrderCancel.classList.contains("hide-element") &&
							btnViewOrderDownload.classList.contains("hide-element") &&
							btnViewOrderViewTrackingHistory.classList.contains("hide-element")){
							viewOrderActions.classList.add("hide-element");
						}
					}, 100)
					
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerShippingAddresses(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.shippingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getReasonsForDeliveryFailure() {
			this.loading = true;
			let request = {
				isActive: true,
			};
			orderService.getFailedReasons(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.reasonsForDeliveryFailure = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadOrderAsPdf(){
			orderService.getOrderDeliveryAsPdf(this.orderId, this.orderDeliveryId);
		},
		onCancelOrderClick(){
			$("#" + this.cancelOrderModalId).modal("show");
		},
		onMarkAsOnDeliveryClick(){
			$("#" + this.markAsOnDeliveryModalId).modal("show");
		},
		onCancelDeliveryScheduleClick() {
			$("#" + this.cancelOrderScheduledForDeliveryModalId).modal("show");
		},
		onRescheduleOrderClick(){
			this.$router.replace("/orders/scheduleOrderForDelivery/" + this.orderId + "/" + this.orderDeliveryId + "/" + this.orderDeliveryScheduleId);
		},
		onCompleteOrderClick(){
			$("#" + this.completeOrderConfirmationModalId).modal("show");
		},
		onCancelYesClick(){
			this.cancelOrder();
		},
		onMarkAsOnDeliveryYesClick(){
			this.markAsOnDelivery();
		},
		onReasonSelect(reason){
			this.cancelDeliverySchedule(reason.failedReasonId);
		},
		onCompleteOrderYesClick(){
			this.completeOrder();
		},
		viewTrackingHistory() {
			this.trackingHistoryModal.showModal = true;
			this.trackingHistoryModal.orderId = this.order.orderId;
			this.trackingHistoryModal.heading = "Tracking History - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		cancelOrder() {
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				orderDeliveryId: this.orderDeliveryId,
				companyId: this.order.companyId
			};
			orderService.cancelDeliveryOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					this.loading = false;
					if(isSuccess){
						$("#" + this.cancelOrderModalId).modal("hide");
						this.$router.go(-1);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		markAsOnDelivery(){
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				companyId: this.order.companyId,
				isOverride: true
			};
			orderService.markDeliveryOrderAsOnDelivery(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					this.loading = false;
					if(isSuccess){
						$("#" + this.markAsOnDeliveryModalId).modal("hide");
						this.$router.go(-1);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		cancelDeliverySchedule(failedReasonId){
			this.loading = true;
			let request = {
				orderDeliveryScheduleId: this.orderDeliveryScheduleId,
				orderDeliveryId: this.orderDeliveryId,
				failedReasonId: failedReasonId,
				companyId: this.order.companyId,
				orderId: this.order.orderId
			};
			orderService.cancelOrderScheduledForDelivery(request).then(
				successResponse => {
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						$("#" + this.cancelOrderScheduledForDeliveryModalId).modal("hide");
						this.$router.go(-1);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDateOfCompletionSelect(date){
			console.log(date);
			this.dateOfCompletion.value = date;
			this.dateOfCompletion.initialiseDate = false;
		},
		onDispenseUpdate(orderItems){
			this.orderItemsDispensed = orderItems;
		},
		completeOrder(){
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				companyId: this.order.companyId,
				isOverride: true,
				orderDispensedItems: this.orderItemsDispensed,
				dateOfCompletion: this.dateOfCompletion.value
			};
			orderService.markDeliveryOrderAsInPendingInvoice(request).then(
				successResponse => {
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.completeOrderValidationResponse.valuesAreValid){
							$("#" + this.completeOrderConfirmationModalId).modal("hide");
							this.$router.go(-1);
						}
						else{
							this.orderItemsHasError = successResponse.data.completeOrderValidationResponse.orderItemsDispensedValidationResponse.hasError;
							this.orderItemsErrorMessage = successResponse.data.completeOrderValidationResponse.orderItemsDispensedValidationResponse.message;
							
							this.dateOfCompletion.hasError = successResponse.data.completeOrderValidationResponse.dateOfCompletionValidationResponse.hasError;
							this.dateOfCompletion.errorMessage = successResponse.data.completeOrderValidationResponse.dateOfCompletionValidationResponse.message;
							
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
				
		},
		setBreadcrumbs() {
			let pageTitle = "View Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		},
		getDeliveryProcessFeatureFlags(){
			settingsService.getDeliveryProcessFeatureFlags().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.deliveryProcessFeatureFlags = successResponse.data.result;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		viewOrderDocuments(){
			this.documentsModal.showModal = true;
			this.documentsModal.orderId = this.order.orderId;
			this.documentsModal.heading = "Order Documents - #" + this.order.orderId;
			this.documentsModal.orderTypeId = orderHelper.orderType.delivery;
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		// this.getProvinces();
		// this.getShippingAreas();
		// this.getShippingZones();
		this.getDeliveryProcessFeatureFlags();
	},
	watch:{
		orderId:{
			handler: function () {
				console.log("companyId", this.orderId);
				if (this.orderId !== null && this.orderId > 0) {
					this.getOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};